import Resources from "../../../resources/resources";
import {EntityType} from "../../../gd/const/item";
import ItemsCollection from "../items-collection";
import Expense from "../../expenses/expense/expense";
import ItemModel from "../item-model"

// const debug = "initExpensesFromResources"
const debug = false

export default function initExpensesFromResources(itemsCollection: ItemsCollection, resources:Resources) {

    debug && console.log(debug, "start()", "expenses records =", resources.expenses?.models.length)

    if (!resources.expenses || resources.expenses.isEmpty) return

    // first of all reset

    _.map(itemsCollection.models, (item)=>{

        switch (item.type) {

            case EntityType.TASK:
                if (item.task.expensesCollection) item.task.expensesCollection.reset()
                break

            case EntityType.PROJECT:
                if (item.project.expensesCollection) item.project.expensesCollection.reset()
                break

            case EntityType.EVENT:
                break
        }

    })

    // link all expenses
    _.map(resources.expenses?.models, (expense:Expense)=>{

        // this is task expense AND task found - add to task
        if (expense.taskId) {
            const taskItems = itemsCollection.getTaskItems(expense.taskId)
            if (!_.isEmpty(taskItems)) {
                _.map(taskItems, (itemModel: ItemModel) => {
                    itemModel.task.addExpense(expense)
                })
                return
            }
        }

        // this is project expense or not task found -> add to project
        const itemProject = itemsCollection.getProject(expense.projectId)!
        if (itemProject) {
            itemProject.project.addExpense(expense)
            return
        }

        console.warn("#9048474 something is wrong - an expense couldnt be linked to any item")

    })

}